import { render, staticRenderFns } from "./ConfigQuestionList.vue?vue&type=template&id=09c494b6"
import script from "./ConfigQuestionList.vue?vue&type=script&lang=js"
export * from "./ConfigQuestionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports